module.exports = __webpack_public_path__ + "img/m1_old.c568e752.png";